export const loadCartState = () => {
    
    try{
        const serializedState = sessionStorage.getItem('CheckoutReducer');       
        if(serializedState === null ){
            console.log('session not found');
            return undefined;
        }
        var state = JSON.parse(serializedState);
        return state.CheckoutReducer;
    }catch(error){
        console.log('session not found');
        return undefined;
    }
}



export const cartSaveState = (state) =>{
    
    try{
        const serializedState = JSON.stringify(state);
        sessionStorage.setItem('CheckoutReducer', serializedState);   
    }catch(error){
        console.log('session could not be saved!');
    }
    
}